import { Component, HostListener, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { Case } from '../../../../../../../../_base-shared/models/Case/Case';
import { AppFile } from '../../../../../../../../_base-shared/models/File/AppFile';
import { User } from '../../../../../../../../_base-shared/models/User/User';
import { SafePipe } from '../../../../../../../../_base-shared/pipes/safe.pipe';
import { environment } from '../../../../../../environments/environment';
import { MainGlobalEventService } from '../../../../../_shared/services/main-global-event.service';
import {
  CaseClientRequestedDocumentListV3Component
} from './case-client-requested-document-list-v3/case-client-requested-document-list-v3.component';
import { CaseCourtDocumentListV3Component } from './case-court-document-list-v3/case-court-document-list-v3.component';

@Component({
  selector:    'app-case-document-list-v3',
  templateUrl: './case-document-list-v3.component.html',
  styleUrls:   ['./case-document-list-v3.component.scss'],
  standalone:  false
})
export class CaseDocumentListV3Component implements OnInit, OnDestroy {
  @Input() case: Case;
  @Input() documentableType!: 'case_creditor' | 'case_public_debt' | 'case_asset';
  @Input() documentableId!: number;
  @ViewChild('clientRequestedDocs') clientRequestedDocs!: CaseClientRequestedDocumentListV3Component;
  @ViewChild('partnerRequestedDocs') partnerRequestedDocs!: CaseClientRequestedDocumentListV3Component;
  @ViewChild('courtClientDocs') courtClientDocs!: CaseCourtDocumentListV3Component;
  @ViewChild('courtPartnerDocs') courtPartnerDocs!: CaseCourtDocumentListV3Component;

  public authUser: User;

  public storageUrl = environment.STORAGE_URL + '/';

  public previewFileUrl: string;
  public previewFileType: string;
  public previewIsSticky             = false;
  public isUserLawyer: boolean;
  public isUserCourtNotificator      = false;
  public isCaseManager               = false;

  private subscriptions: Subscription[] = [];

  @HostListener('window:scroll', ['$event'])
  checkScroll(): void {
    this.previewIsSticky = window.pageYOffset >= 600;
  }

  constructor(private safePipe: SafePipe,
              public dialog: MatDialog,
              public globalEventsService: MainGlobalEventService,
              protected toastr: ToastrService,
              protected translate: TranslateService) {
  }

  ngOnInit(): void {
    this.subscriptions.push(this.globalEventsService.authUser$.subscribe(user => {
      this.authUser = user;
      this.authUser.departments.forEach(department => {
        if (department.type === 'lawyer') {
          this.isUserLawyer = true;
        } else if (department.type === 'court-notificator') {
          this.isUserCourtNotificator = true;
        }
        else if (department?.type === 'case-manager') {
          this.isCaseManager = true;
        }
      });
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: Subscription) => subscription.unsubscribe());
  }

  public previewFile(documentFile: AppFile): void {
    const url = this.storageUrl + documentFile.path;
    const mime = documentFile.mime_type || '';

    if (
      mime.includes('officedocument') ||
      mime.includes('msword') ||
      mime.includes('msexcel') ||
      mime.includes('mspowerpoint')
    ) {
      this.toastr.error(this.translate.instant('DOCUMENTS.document_preview_disabled_warning'))
      return;

    } else {
      this.previewFileUrl  = this.safePipe.transform(url + '?output=embed', 'resourceUrl') as string;
      this.previewFileType = documentFile.mime_type?.includes('image') ? 'image' : 'object';
    }
  }

  public closeFilePreview(): void {
    this.previewFileUrl  = null;
    this.previewFileType = '';
  }

  public reloadRequestedDocList(clientRole: 'client' | 'partner'): void {
    if (clientRole === 'client') {
      this.clientRequestedDocs.loadDocumentTypeCategories();
    } else {
      this.partnerRequestedDocs.loadDocumentTypeCategories();
    }
  }

  public addUpdatedFileToDocList($event: AppFile, componentList: 'clientList' | 'courtList', clientRole: 'client' | 'partner'): void {
    if (componentList === 'clientList') {
      if (clientRole === 'client') {
        console.log('adding to client list client role');
        this.clientRequestedDocs.appendUpdatedFile($event);
      } else {
        console.log('adding to client list partner role');
        this.partnerRequestedDocs.appendUpdatedFile($event);
      }
    } else {
      if (clientRole === 'client') {
        console.log('adding to court list client role');
        this.courtClientDocs.appendUpdatedFile($event);
      } else {
        console.log('adding to court list partner role');
        this.courtPartnerDocs.appendUpdatedFile($event);
      }
    }
  }

}
